import React, { type ReactNode } from "react";
import { SwipeableDrawer, Toolbar } from "@mui/material";

interface Props {
  open: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  contents: ReactNode;
}

const Drawer: React.FC<Props> = (props) => {
  const { open, handleClose, handleOpen, contents } = props;

  return (
    <SwipeableDrawer
      closeAfterTransition={true}
      open={open}
      anchor="right"
      variant="temporary"
      onOpen={handleOpen}
      onClose={handleClose}
      sx={{
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar />
      {contents}
    </SwipeableDrawer>
  );
};

export default Drawer;
